import { Controller } from "stimulus";

// Turns the weekly "most shifts" number into hours as the Weployee types; 0 means not available.
export default class extends Controller {
  static targets = ["input", "hint"];
  static values = {
    shiftHours: Number,
    blank: String,
    unavailable: String,
    hours: String,
  };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly hintTarget: HTMLElement;
  declare readonly shiftHoursValue: number;
  declare readonly blankValue: string;
  declare readonly unavailableValue: string;
  declare readonly hoursValue: string;

  update(): void {
    const shifts = Number(this.inputTarget.value);

    if (
      this.inputTarget.value.trim() === "" ||
      !Number.isInteger(shifts) ||
      shifts < 0
    ) {
      this.hintTarget.textContent = this.blankValue;
    } else if (shifts === 0) {
      this.hintTarget.textContent = this.unavailableValue;
    } else {
      this.hintTarget.textContent = this.hoursValue.replace(
        "%{hours}",
        String(shifts * this.shiftHoursValue)
      );
    }
  }
}
